import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as urls from "../utility/urls";

@Injectable({
  providedIn: 'root'
})
export class InstitucionService {

  constructor(
    private http: HttpClient,
  ) { }

  getInstitucion( slug: string): Observable<any> {
    return this.http.get<any>(environment.rediApi + urls.getInstitucionLanding + slug);
  }
  getInstitucionStaff( slug: string, especialidad_uid?: string): Observable<any> {
    if(especialidad_uid) {
      var params = new HttpParams().set('especialidad',especialidad_uid);
      return this.http.get<any>(environment.rediApi + urls.getInstitucionStaff + slug, {params: params});
    }
    else {
      var params = new HttpParams().set('especialidad','');
      return this.http.get<any>(environment.rediApi + urls.getInstitucionStaff + slug, {params: params});
    }
  }
  getInstitucionUnidad( slug:string): Observable<any> {
    return this.http.get<any>(environment.rediApi + urls.getInstitucionUnidad + slug);
  }
}
